import { ExperienceMessage } from 'data/records'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { collection, resource, findSelector } from 'data/helpers/apiv3'
import { Map, Set } from 'immutable'
import { loadAllPages } from 'lib/loadAllPages'

const [api, actions] = resource(ExperienceMessage, [
  ['list', collection.get('', ['experienceId'])]
])
actions.loadAll = (experienceId, params) => (dispatch) => {
  const loadMessagesPage = ({ pageIndex: page, perPage }) => (
    dispatch(actions.list(experienceId, { page, perPage, ...params }))
  )
  const isLastPage = ({ perPage, pageIndex, pageResults }) => {
    return perPage * (pageIndex + 1) >= pageResults.value.totalCount
  }

  return loadAllPages({
    promiseProducer: loadMessagesPage,
    perPage: 100,
    isLastPage
  })
}

const selectors = {
  ...findSelector(ExperienceMessage),
  byExperienceId: (state, experienceId) => {
    const slice = state.apiv3.experienceMessage.idsByExperienceId
    return slice.get(experienceId, Set()).map(mId => selectors.find(state, mId))
  }
}

const reducers = {
  [fulfilled(actions.list.type)]: (state, action) => {
    const { experience_id: experienceId } = action.payload.meta
    const prevSet = state.getIn(['idsByExperienceId', experienceId], Set())
    const nextSet = prevSet.union(action.payload.results.map(m => m.id))
    return state.setIn(['idsByExperienceId', experienceId], nextSet)
  },
  [fulfilled(actions.create.type)]: (state, action) => {
    const { experienceMessage } = action.payload
    const prevSet = state.getIn(['idsByExperienceId', experienceMessage.experienceId], Set())
    const nextSet = prevSet.add(experienceMessage.id)
    return state.setIn(['idsByExperienceId', experienceMessage.experienceId], nextSet)
  }
}

const initialState = {
  idsByExperienceId: Map() // experienceId -> Set(experienceMessageIds)
}

export {
  api as experienceMessageApi,
  actions as experienceMessageActions,
  selectors as experienceMessageSelectors,
  reducers as experienceMessageReducers,
  initialState as experienceMessageInitialState
}
